import React from 'react';
import PropTypes from 'prop-types';
import AutocompleteMultilineField from '@/modules/common/components/AutocompleteMultilineField';

function getOptions(types) {
    let options = [];
    types.forEach((type) => {
        if (!options.includes(type.name)) {
            options.push(type.name);
        }
    });
    return options.sort();
}

const AutocompleteTypeNameField = (props) => {
    return (
        <AutocompleteMultilineField className="types" label={(props.showLabel) ? 'Тип заявки': ''}
                                    options={getOptions(props.types)}
                                    value={props.value} setValue={props.setValue} {...props}
        />
    );
};

AutocompleteTypeNameField.propTypes = {
    types: PropTypes.array.isRequired,
    value: PropTypes.array.isRequired,
    setValue: PropTypes.func.isRequired,
    showLabel: PropTypes.bool,
};

AutocompleteTypeNameField.defaultProps = {
    showLabel: true,
};

export default AutocompleteTypeNameField;
